import React from 'react';
import { useShowContext } from 'framework/show';
import { Box, Grid2, Typography } from '@mui/material';
import BalancesLeavesField from './BalancesLeavesField';
import BalancesLeavesStatusField from './BalancesLeavesStatusField';
import NumberOfCalendarDaysField from './NumberOfCalendarDaysField';
import { MappedLeaveItem, ProcessedLeaveYear } from '../../shared/types';
import ViewDetailsButton from '../shared/ViewDetailsButton';

interface LeaveDetailsFieldProps {
  hideShowDetailsButtons?: boolean;
}

const LeaveDetailsField: React.FC<LeaveDetailsFieldProps> = ({ hideShowDetailsButtons = false }) => {
  const { data } = useShowContext<ProcessedLeaveYear>();
  const period = data?.getData();

  if (!period?.leaves?.length) return null;

  return (
    <Box mx={2} my={1} color="secondary">
      {period.leaves.map((leave: MappedLeaveItem, index: number) => (
        <Typography color="secondary" key={leave.id ?? index}>
          <Grid2
            container
            sx={{
              padding: '4px 0',
              alignItems: 'center',
            }}
            justifyContent="space-between"
          >
            <Grid2 size={4} pl={4}>
              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                <BalancesLeavesField source="startDate" value={leave} />
                <span>-</span>
                <BalancesLeavesField source="endDate" value={leave} />
              </Box>
            </Grid2>
            <Grid2 size={2}>
              <NumberOfCalendarDaysField value={leave} />
            </Grid2>
            <Grid2 size={3.5}>
              <BalancesLeavesStatusField value={leave} />
            </Grid2>
            <Grid2 size={2}> {!hideShowDetailsButtons && <ViewDetailsButton leaveId={leave.id ?? index} />} </Grid2>
          </Grid2>
        </Typography>
      ))}
    </Box>
  );
};

export default LeaveDetailsField;
